import store from "@/store";
import router from "@/router";
import { isTokenValid } from "@/shared/token";

// Mensagem do AdminAuthGuard da API quando recusa o token (ausente, expirado
// ou invalido). O outro 401 do backoffice e o "Senha incorreta." da
// confirmacao de exclusao, que e erro de formulario e nao derruba a sessao.
const TOKEN_REJECTED_MESSAGE = "nao autorizado";

export function clearSession() {
  store.dispatch("setUser", null);
  store.dispatch("setToken", null);
  store.dispatch("setRefreshToken", null);
  store.dispatch("setAccess", null);
}

// 401 em que a API recusou a sessao, e nao uma senha digitada errada.
export function isSessionRejected(error) {
  if (error?.response?.status !== 401) return false;
  const message = error.response.data?.message;
  return (
    message === TOKEN_REJECTED_MESSAGE ||
    !isTokenValid(localStorage.getItem("token"))
  );
}

// Encerra a sessao e manda para o login, guardando a pagina atual para voltar
// depois de entrar. Varias chamadas recusadas ao mesmo tempo redirecionam uma
// vez so.
export function endSession() {
  clearSession();
  const current = router.currentRoute;
  if (current.path === "/sign-in") return;
  const query =
    current.fullPath && current.fullPath !== "/"
      ? { redirect: current.fullPath }
      : {};
  router.replace({ path: "/sign-in", query }).catch(() => {});
}
